import React, { useEffect, useState } from 'react';

import euFlag from 'assets/Images/eu.svg';
import svFlag from 'assets/flags/sv.svg';
import {
  NumberOfTests,
  Increment,
  Decrement,
  EditablePlan,
  PlanContainer,
  CurrencyContainer,
  PlanType,
  PlanDiv,
  PlanCurrency,
  PlanHeader,
  CurrencyFlag,
  CurrencyDropdownButton,
  DropdownMenuBlock,
  DropdownItem,
  DiscountedPrice,
  PurchaseTab,
  OffersContainer,
  Offer,
} from './styles';

export default function PurchaseSelection({ purchaseData, setPurchaseDetails }) {
  const currencies = Object.keys(purchaseData.price);

  const [selectedCurrency, setSelectedCurrency] = useState(Object.keys(purchaseData.price)?.[0]);
  const [price, setPrice] = useState(purchaseData?.price?.[Object.keys(purchaseData.price)?.[0]]);
  const [discountPrice, setDiscountPrice] = useState(purchaseData?.price?.[Object.keys(purchaseData.price)?.[0]]);
  const [credits, setCredits] = useState(1);

  useEffect(() => {
    const newPrice = purchaseData.price[selectedCurrency] * credits;

    let newDiscountPrice;
    if (credits >= 10 && credits <= 19) {
      newDiscountPrice = newPrice - (newPrice / 100) * 15;
    } else if (credits >= 20) {
      newDiscountPrice = newPrice - (newPrice / 100) * 25;
    } else {
      newDiscountPrice = newPrice;
    }

    setPrice(newPrice);
    setDiscountPrice(newDiscountPrice);
    setPurchaseDetails({
      ...purchaseData,
      type: purchaseData.name,
      credits: credits,
      price: newPrice,
      selectedCurrency: selectedCurrency,
    });
  }, [credits, selectedCurrency, purchaseData, setPurchaseDetails]);

  return (
    <PurchaseTab>
      <OffersContainer>
        <Offer>
          Get <b>15%</b> off on 10 or more tests
        </Offer>
        <br />
        <Offer>
          Get <b>25%</b> off on 20 or more tests
        </Offer>
      </OffersContainer>
      <PlanContainer>
        <PlanType>
          <p>Select Tests</p>
        </PlanType>
        <PlanDiv>
          <PlanHeader discounted={discountPrice !== price}>
            {discountPrice !== price && (
              <DiscountedPrice>
                {price}
                <PlanCurrency>{selectedCurrency}</PlanCurrency>
              </DiscountedPrice>
            )}
            <CurrencyContainer>
              {discountPrice}
              <CurrencyDropdownButton
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {selectedCurrency}
              </CurrencyDropdownButton>
              <DropdownMenuBlock aria-labelledby="dropdownMenuButton">
                {currencies.map((currency, key) => {
                  return (
                    <DropdownItem key={key} value={currency} onClick={() => setSelectedCurrency(currency)}>
                      {currency}
                      <CurrencyFlag src={currency === 'SEK' ? svFlag : euFlag} />
                    </DropdownItem>
                  );
                })}
              </DropdownMenuBlock>
            </CurrencyContainer>
            <EditablePlan>
              <Decrement onClick={() => credits > 1 && setCredits(credits - 1)}>-</Decrement>
              <NumberOfTests>{credits}</NumberOfTests>
              <Increment onClick={() => setCredits(credits + 1)}>+</Increment>
            </EditablePlan>
          </PlanHeader>
        </PlanDiv>
      </PlanContainer>
    </PurchaseTab>
  );
}
